import RouterViewBody from '~/views/RouterViewBody.vue'
import store from '~/store/index.js'
const interfaceGroups = store.getters['interfaceGroup/interfaceGroupIdList']
export default [
  {
    path: 'web',
    component: RouterViewBody,
    meta: {
      breadCrumb: 'Web',
    },
    children: [
      {
        path: '',
        name: 'settingInterfaceWeb',
        component: () => import('~/views/settingPage/interface/settingInterfaceWeb.vue'),
      },
      {
        path: 'footer',
        name: 'settingInterfaceWebFooter',
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          interfaceGroupId: interfaceGroups.web.footer.text,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages['setting-interface'].common.footer,
        },
      },
      {
        path: 'pages',
        name: 'settingInterfaceWebPages',
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          interfaceGroupId: interfaceGroups.web.pages.buttons,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages['setting-interface'].common.pages_name,
        },
      },
      {
        path: 'chat',
        name: 'settingInterfaceWebChat',
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          interfaceGroupId: interfaceGroups.web.chat.all,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages['chat'].all.chat,
        },
      },
      {
        path: 'home',
        name: 'settingInterfaceWebHome',
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          interfaceGroupId: interfaceGroups.web.home.main,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.pages.buttons.glavnaya,
        },
      },
      {
        path: 'planning',
        name: 'settingInterfaceWebPlanning',
        redirect: {
          name: 'settingInterfaceWeb',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.pages.buttons.planirovanie,
        },
        children: [
          {
            path: 'pages',
            name: 'settingInterfaceWebPlanningPages',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.planning.pages,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.pages_name,
            },
          },
          // {
          //     path: 'orders',
          //     name: 'settingInterfaceWebPlanningOrders',
          //     component: () =>
          //         import(
          //             '~/views/settingPage/interface/settingInterfaceEdit.vue'
          //         ),
          //     redirect: {
          //         name: 'settingInterfaceWeb'
          //     },
          //     meta: {
          //         breadCrumb: 'Обьем заказов'
          //     },
          //     children: [

          //     ]
          // },
          {
            path: 'table',
            name: 'settingInterfaceWebPlanningOrdersTable',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.planning.orders.table,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
            },
          },
        ],
      },
      {
        path: 'sales',
        name: 'settingInterfaceWebSales',
        redirect: {
          name: 'settingInterfaceWeb',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.pages.buttons.prodazhi,
        },
        children: [
          {
            path: 'pages',
            name: 'settingInterfaceWebSalesPages',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.sales.pages,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.pages_name,
            },
          },
          {
            path: 'buttons',
            name: 'settingInterfaceWebSalesButtons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.sales.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
          {
            path: 'status',
            name: 'settingInterfaceWebSalesStatus',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.projects_status.status,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.status,
            },
          },
          {
            path: 'project',
            name: 'settingInterfaceWebSalesProject',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.pages.buttons.proekty,
            },
            children: [
              {
                path: 'sections',
                name: 'settingInterfaceWebSalesProjectSections',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.sales.project.sections,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.sections_name,
                },
              },
              {
                path: 'buttons',
                name: 'settingInterfaceWebSalesProjectButtons',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.sales.project.buttons,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.buttons,
                },
              },
              {
                path: 'project-client',
                name: 'settingInterfaceWebSalesProjectProjectClient',
                redirect: {
                  name: 'settingInterfaceWeb',
                },
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.sales_project.sections['proektnye-i-klientskie-dannye'],
                },
                children: [
                  {
                    path: 'sections',
                    name: 'settingInterfaceWebSalesProjectProjectClientSections',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.sales.project['project-client'].sections,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.sections_name,
                    },
                  },
                  {
                    path: 'buttons',
                    name: 'settingInterfaceWebSalesProjectProjectClientButtons',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.sales.project['project-client'].buttons,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.buttons,
                    },
                  },
                  {
                    path: 'labels',
                    name: 'settingInterfaceWebSalesProjectProjectClientLabels',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.sales.project['project-client'].labels,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.labels,
                    },
                  },
                  {
                    path: 'inputs',
                    name: 'settingInterfaceWebSalesProjectProjectClientInputs',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.sales.project['project-client'].inputs,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.inputs,
                    },
                  },
                  {
                    path: 'tooltips',
                    name: 'settingInterfaceWebSalesProjectProjectClientTooltips',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.sales.project['project-client'].tooltips,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.tooltips,
                    },
                  },
                ],
              },
              {
                path: 'schemes-documents',
                name: 'settingInterfaceWebSalesProjectSchemesDocuments',
                redirect: {
                  name: 'settingInterfaceWeb',
                },
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.sales_project.sections['chertezhi-i-dokumenty'],
                },
                children: [
                  {
                    path: 'sections',
                    name: 'settingInterfaceWebSalesProjectSchemesDocumentsSections',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.sales.project['schemes-documents'].sections,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.sections_name,
                    },
                  },
                  {
                    path: 'tooltips',
                    name: 'settingInterfaceWebSalesProjectSchemesDocumentsTooltips',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.sales.project['schemes-documents'].tooltips,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.tooltips,
                    },
                  },
                  {
                    path: 'tables',
                    name: 'settingInterfaceWebSalesProjectSchemesDocumentsTables',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.sales.project['schemes-documents'].tables,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.tables,
                    },
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSalesProjectSchemesDocumentsDelete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.sales.project['schemes-documents'].dialog.delete,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                    },
                  },
                ],
              },
              {
                path: 'material-price',
                name: 'settingInterfaceWebSalesProjectMaterialPrice',
                redirect: {
                  name: 'settingInterfaceWeb',
                },
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.sales_project.sections['materialy-i-tseny'],
                },
                children: [
                  {
                    path: 'tooltips',
                    name: 'settingInterfaceWebSalesProjectMaterialPriceTooltips',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.sales.project['material-price'].tooltips,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.tooltips,
                    },
                  },
                  {
                    path: 'tables',
                    name: 'settingInterfaceWebSalesProjectMaterialPriceTables',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.sales.project['material-price'].tables,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.tables,
                    },
                  },
                ],
              },
              {
                path: 'planned-resources',
                name: 'settingInterfaceWebSalesProjectPlannedResources',
                redirect: {
                  name: 'settingInterfaceWeb',
                },
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.sales_project.sections['planiruemye-resursy'],
                },
                children: [
                  {
                    path: 'labels',
                    name: 'settingInterfaceWebSalesProjectPlannedResourcesLabels',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.sales.project['planned-resources'].labels,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.labels,
                    },
                  },
                  {
                    path: 'responsible-employees',
                    name: 'settingInterfaceWebSalesProjectPlannedResourcesResponsibleEmployees',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.sales.project['planned-resources'].responsibleEmployees
                          .id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages.sales_project['planned_resources-responsible_employees'][
                          'main'
                        ],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSalesProjectPlannedResourcesResponsibleEmployeesLabels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.sales.project['planned-resources']
                              .responsibleEmployees.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSalesProjectPlannedResourcesResponsibleEmployeesButtons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.sales.project['planned-resources']
                              .responsibleEmployees.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                      {
                        path: 'delete',
                        name: 'settingInterfaceWebSalesProjectPlannedResourcesResponsibleEmployeesDelete',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.sales.project['planned-resources']
                              .responsibleEmployees.delete,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.delete,
                        },
                      },
                    ],
                  },
                  {
                    path: 'subscribers',
                    name: 'settingInterfaceWebSalesProjectPlannedResourcesSubscribers',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.sales.project['planned-resources'].subscribers,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['sales_project']['planned_resources-subscribers'].title,
                    },
                  },
                  {
                    path: 'period',
                    name: 'settingInterfaceWebSalesProjectPlannedResourcesPeriod',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.sales.project['planned-resources']['time-period'].id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages.sales_project['planned_resources-time_period']['main'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSalesProjectPlannedResourcesPeriodLabels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.sales.project['planned-resources']['time-period']
                              .labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'inputs',
                        name: 'settingInterfaceWebSalesProjectPlannedResourcesPeriodInputs',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.sales.project['planned-resources']['time-period']
                              .inputs,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.inputs,
                        },
                      },
                      {
                        path: 'tooltips',
                        name: 'settingInterfaceWebSalesProjectPlannedResourcesPeriodTooltips',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.sales.project['planned-resources']['time-period']
                              .tooltips,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.tooltips,
                        },
                      },
                      {
                        path: 'delete',
                        name: 'settingInterfaceWebSalesProjectPlannedResourcesPeriodDelete',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.sales.project['planned-resources']['time-period']
                              .delete,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.delete,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                path: 'price-offer-terms',
                name: 'settingInterfaceWebSalesProject_priceOfferTerms',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.sales.project.price_offer_terms.id,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.sales_project.price_offer_terms['title'],
                },
                children: [
                  {
                    path: 'labels',
                    name: 'settingInterfaceWebSalesProject_priceOfferTerms_labels',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.sales.project.price_offer_terms.labels,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.labels,
                    },
                  },
                  {
                    path: 'tables',
                    name: 'settingInterfaceWebSalesProject_priceOfferTerms_tables',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.sales.project.price_offer_terms.tables,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.tables,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'projects',
        name: 'settingInterfaceWebProjects',
        redirect: {
          name: 'settingInterfaceWeb',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.pages.buttons.proekty,
        },
        children: [
          {
            path: 'pages',
            name: 'settingInterfaceWebProjectsPages',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.projects.pages,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.pages_name,
            },
          },
          {
            path: 'reports',
            name: 'settingInterfaceWebProjectsReports',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['projects'].pages.reports,
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebProjectsReportsTables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.projects.reports.table,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebProjectsReportsDialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.projects.reports.dialogs,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
              },
            ],
          },
          {
            path: 'statistic',
            name: 'settingInterfaceWebProjectsStatistic',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['projects'].pages.statistics,
            },
            children: [
              {
                path: 'project',
                name: 'settingInterfaceWebProjectsStatisticProject',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.statistic.project.text,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.pages.buttons.proekty,
                },
                children: [
                  {
                    path: 'tables',
                    name: 'settingInterfaceWebProjectsStatisticProjectTables',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.statistic.project.tables,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.tables,
                    },
                  },
                ],
              },
              {
                path: 'employee',
                name: 'settingInterfaceWebProjectsStatisticEmployee',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.statistic.employee.text,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.personnel_department.pages.sotrudniki,
                },
                children: [
                  {
                    path: 'tables',
                    name: 'settingInterfaceWebProjectsStatisticEmployeeTables',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.statistic.employee.tables,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.tables,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'personnel-department',
        name: 'settingInterfaceWebPersonnelDepartment',
        redirect: {
          name: 'settingInterfaceWeb',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.pages.buttons['otdel-kadrov'],
        },
        children: [
          {
            path: 'pages',
            name: 'settingInterfaceWebPersonnelDepartmentPages',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.personnelDepartment.pages,
              breadCrumb: 'Страницы',
            },
          },
          {
            path: 'employees',
            name: 'settingInterfaceWebPersonnelDepartmentEmployees',
            redirect: {
              name: 'settingInterfaceWeb',
            },
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.personnel_department.pages.sotrudniki,
            },
            children: [
              {
                path: 'dialogs',
                name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogs',
                redirect: {
                  name: 'settingInterfaceWeb',
                },
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add',
                    name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsAdd',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.personnelDepartment.employees.dialogs.employeeAdd.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages.personnel_department.dialog_addemployee_buttons[
                          'dobavit-sotrudnika'
                        ],
                    },
                    children: [
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsAddButtons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employees.dialogs.employeeAdd
                              .buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsAddLabels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employees.dialogs.employeeAdd
                              .labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                    ],
                  },
                  {
                    path: 'invitation',
                    name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsInvitation',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.personnelDepartment.employees.dialogs.employeeInvitation
                          .id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages.personnel_department.dialog_employeeinvitation_buttons[
                          'priglashenie-sotrudnika-v-proapp'
                        ],
                    },
                    children: [
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsInvitationButtons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employees.dialogs
                              .employeeInvitation.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsInvitationLabels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employees.dialogs
                              .employeeInvitation.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'inputs',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsInvitationInputs',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employees.dialogs
                              .employeeInvitation.inputs,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.inputs,
                        },
                      },
                    ],
                  },
                  {
                    path: 'position-appointment',
                    name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsPositionAppointment',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.personnelDepartment.employees.dialogs
                          .employeePositionAppointment.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages.personnel_department
                          .dialog_employeepositionappointment_buttons['naznachit-dolzhnost'],
                    },
                    children: [
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsPositionAppointmentnButtons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employees.dialogs
                              .employeePositionAppointment.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsPositionAppointmentLabels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employees.dialogs
                              .employeePositionAppointment.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'inputs',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsPositionAppointmentInputs',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employees.dialogs
                              .employeePositionAppointment.inputs,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.inputs,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                path: 'card',
                name: 'settingInterfaceWebPersonnelDepartmentEmployeesCard',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.personnelDepartment.employees.card,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages.personnel_department.employees_card.main,
                },
              },
            ],
          },
          {
            path: 'employees-group',
            name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroup',
            redirect: {
              name: 'settingInterfaceWeb',
            },
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.personnelDepartment.employeesGroup.id,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages.personnel_department.pages.podrazdeleniya,
            },
            children: [
              {
                path: 'dialogs',
                name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogs',
                redirect: {
                  name: 'settingInterfaceWeb',
                },
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'create-edit',
                    name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsCreateEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.personnelDepartment.employeesGroup.dialogs.createEdit
                          .id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsCreateEditButtons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employeesGroup.dialogs
                              .createEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsCreateEditLabels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employeesGroup.dialogs
                              .createEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsDelete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.personnelDepartment.employeesGroup.dialogs.delete,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                    },
                  },
                  {
                    path: 'additional-project',
                    name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsAdditionalProject',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.personnelDepartment.employeesGroup.dialogs
                          .additional_project.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages.personnel_department[
                          'employees_group-dialog-additional_project-buttons'
                        ].add,
                    },
                    children: [
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsAdditionalProjectButtons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employeesGroup.dialogs
                              .additional_project.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsAdditionalProjectLabels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employeesGroup.dialogs
                              .additional_project.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'delete',
                        name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsAdditionalProjectDelete',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.personnelDepartment.employeesGroup.dialogs
                              .additional_project.delete,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.delete,
                        },
                      },
                    ],
                  },
                ],
              },
              {
                path: 'tables',
                name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupTables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.personnelDepartment.employeesGroup.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'sections',
                name: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupSections',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.personnelDepartment.employeesGroup.sections,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.sections,
                },
              },
            ],
          },
        ],
      },
      {
        path: 'clients',
        name: 'settingInterfaceWeb_clients',
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        redirect: {
          name: 'settingInterfaceWeb',
        },
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['klienty'],
        },
        children: [
          {
            path: 'tables',
            name: 'settingInterfaceWeb_clients_tables',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.setting.clients.tables,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
            },
          },
          {
            path: 'dialogs',
            name: 'settingInterfaceWeb_clients_dialogs',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },

            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-interface'].common.dialogs,
            },
            children: [
              {
                path: 'add-edit',
                name: 'settingInterfaceWeb_clients_dialogs_addEdit',
                component: () =>
                  import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.clients.dialogs.addEdit.id,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common['dialogs-add_edit'],
                },
                children: [
                  {
                    path: 'labels',
                    name: 'settingInterfaceWeb_clients_dialogs_addEdit_labels',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.dialogs.addEdit.labels,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.labels,
                    },
                  },
                  {
                    path: 'buttons',
                    name: 'settingInterfaceWeb_clients_dialogs_addEdit_buttons',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.dialogs.addEdit.buttons,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.buttons,
                    },
                  },
                ],
              },
              {
                path: 'address',
                name: 'settingInterfaceWeb_clients_dialogs_address',
                component: () =>
                  import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.clients.dialogs.address.id,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-client']['dialog-adress']['main'],
                },
                children: [
                  {
                    path: 'labels',
                    name: 'settingInterfaceWeb_clients_dialogs_address_labels',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.dialogs.address.labels,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.labels,
                    },
                  },
                  {
                    path: 'buttons',
                    name: 'settingInterfaceWeb_clients_dialogs_address_buttons',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.dialogs.address.buttons,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.buttons,
                    },
                  },
                  {
                    path: 'checkbox',
                    name: 'settingInterfaceWeb_clients_dialogs_address_checkbox',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.dialogs.address.checkbox,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.checkbox,
                    },
                  },
                ],
              },
              {
                path: 'delete',
                name: 'settingInterfaceWeb_clients_dialogs_delete',
                component: () =>
                  import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.delete,
                  interfaceGroupId: interfaceGroups.web.setting.clients.dialogs.delete,
                },
              },
            ],
          },
          {
            path: 'address',
            name: 'settingInterfaceWeb_clients_address',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.setting.clients.address.id,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-client']['address']['adresa'],
            },
            children: [
              {
                path: 'dialogs',
                name: 'settingInterfaceWeb_clients_address_dialogs',
                component: () =>
                  import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWeb_clients_address_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.address.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWeb_clients_address_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.clients.address.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWeb_clients_address_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.address.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'contacts',
            name: 'settingInterfaceWeb_clients_contacts',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.setting.clients.contacts.id,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-client']['contacts']['kontakty'],
            },
            children: [
              {
                path: 'dialogs',
                name: 'settingInterfaceWeb_clients_contacts_dialogs',
                component: () =>
                  import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWeb_clients_contacts_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.contacts.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWeb_clients_contacts_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.clients.contacts.dialogs.addEdit
                              .buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWeb_clients_contacts_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.contacts.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'persons',
            name: 'settingInterfaceWeb_clients_persons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.setting.clients.persons.id,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-client']['persons']['kontaktnye-litsa'],
            },
            children: [
              {
                path: 'dialogs',
                name: 'settingInterfaceWeb_clients_persons_dialogs',
                component: () =>
                  import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWeb_clients_persons_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.persons.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWeb_clients_persons_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.clients.persons.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWeb_clients_persons_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.persons.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'offices',
            name: 'settingInterfaceWeb_clients_offices',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.setting.clients.offices.id,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-client']['offices']['filialy'],
            },
            children: [
              {
                path: 'dialogs',
                name: 'settingInterfaceWeb_clients_offices_dialogs',
                component: () =>
                  import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWeb_clients_offices_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.offices.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWeb_clients_offices_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.clients.offices.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWeb_clients_offices_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId:
                        interfaceGroups.web.setting.clients.offices.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'menu',
        name: 'settingInterfaceWebMenu',
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          interfaceGroupId: interfaceGroups.web.menu.header,
          breadCrumb: 'Меню',
        },
      },
      {
        path: 'setting',
        name: 'settingInterfaceWebSetting',
        redirect: {
          name: 'settingInterfaceWeb',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.pages.buttons.nastroyki,
        },
        children: [
          {
            path: 'pages',
            name: 'settingInterfaceWebSettingPages',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.setting.pages,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.pages_name,
            },
          },
          {
            path: 'personal-area',
            name: 'settingInterfaceWebSetting_personalArea',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['lichnyy-kabinet'],
            },
            children: [
              {
                path: 'sections',
                name: 'settingInterfaceWebSetting_personalArea_sections',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.personalArea.sections,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.sections,
                },
              },
              {
                path: 'labels',
                name: 'settingInterfaceWebSetting_personalArea_labels',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.personalArea.labels,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
                },
              },
              {
                path: 'buttons',
                name: 'settingInterfaceWebSetting_personalArea_buttons',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.personalArea.buttons,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.buttons,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_personalArea_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'new_address',
                    name: 'settingInterfaceWebSetting_personalArea_dialogs_newAddress',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.personalArea.dialog.new_address,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-personal_area']['dialog-new_address'][
                          'title_add'
                        ],
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'roles',
            name: 'settingInterfaceWebSetting_Roles',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },

            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['roli'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_Roles_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                  interfaceGroupId: interfaceGroups.web.setting.roles.tables,
                },
              },
              {
                path: 'buttons',
                name: 'settingInterfaceWebSetting_Roles_buttons',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.roles.buttons,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.buttons,
                },
              },
              {
                path: 'labels',
                name: 'settingInterfaceWebSetting_Roles_labels',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.roles.labels,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
                },
              },
              {
                path: 'access-types',
                name: 'settingInterfaceWebSetting_Roles_accessTypes',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.roles.accessTypes.id,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-roles']['access-types']['nastroyka-tipov-dostupov'],
                },
                children: [
                  {
                    path: 'inputs',
                    name: 'settingInterfaceWebSetting_Roles_accessTypes_inputs',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.roles.accessTypes.inputs,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.inputs,
                    },
                  },
                  {
                    path: 'planning',
                    name: 'settingInterfaceWebSetting_Roles_accessTypes_planning',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.roles.accessTypes.planning,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-roles']['access-types_planning'].planirovanie,
                    },
                  },
                  {
                    path: 'sales',
                    name: 'settingInterfaceWebSetting_Roles_accessTypes_sales',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.roles.accessTypes.sales,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-roles']['access-types_sales'].prodazhi,
                    },
                  },
                  {
                    path: 'time-сontrol',
                    name: 'settingInterfaceWebSetting_Roles_accessTypes_timeControl',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.roles.accessTypes.timeControl,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-roles']['access-types_time-control'][
                          'kontrol-rabochego-vremeni'
                        ],
                    },
                  },
                  {
                    path: 'employees',
                    name: 'settingInterfaceWebSetting_Roles_accessTypes_employees',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.roles.accessTypes.employees,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-roles']['access-types_employees']['sotrudniki'],
                    },
                  },
                  {
                    path: 'personal-area',
                    name: 'settingInterfaceWebSetting_Roles_accessTypes_personalArea',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.roles.accessTypes.personalArea,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-roles']['access-types_personal-area'][
                          'lichnyy-kabinet'
                        ],
                    },
                  },
                  {
                    path: 'setting',
                    name: 'settingInterfaceWebSetting_Roles_accessTypes_setting',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.roles.accessTypes.setting,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-roles']['access-types_setting']['nastroyki'],
                    },
                  },
                ],
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_Roles_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_Roles_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.roles.dialogs.delete,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'users',
            name: 'settingInterfaceWebSetting_users',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },

            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['polzovateli'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_users_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                  interfaceGroupId: interfaceGroups.web.setting.users.tables,
                },
              },
              {
                path: 'status',
                name: 'settingInterfaceWebSetting_users_status',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.status,
                  interfaceGroupId: interfaceGroups.web.setting.users.status,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_users_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'edit',
                    name: 'settingInterfaceWebSetting_users_dialogs_edit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.users.dialogs.edit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-users']['dialog-edit'][
                          'redaktirovanie-polzovatelya'
                        ],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_users_dialogs_edit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId: interfaceGroups.web.setting.users.dialogs.edit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_users_dialogs_edit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId: interfaceGroups.web.setting.users.dialogs.edit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'add',
                    name: 'settingInterfaceWebSetting_users_dialogs_add',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.users.dialogs.add.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-users']['dialog-add']['priglashenie-v-proapp'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_users_dialogs_add_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId: interfaceGroups.web.setting.users.dialogs.add.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_users_dialogs_add_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId: interfaceGroups.web.setting.users.dialogs.add.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'assign-role',
                    name: 'settingInterfaceWebSetting_users_dialogs_assignRole',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.users.dialogs.assignRole.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-users']['dialog-assign_role']['naznachit-rol'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_users_dialogs_assignRole_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.users.dialogs.assignRole.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_users_dialogs_assignRole_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.users.dialogs.assignRole.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_users_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.users.dialogs.delete,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'interface',
            name: 'settingInterfaceWebSetting_interface',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },

            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages.setting.pages['administrirovanie-interfeysa'],
            },
            children: [
              {
                path: 'common',
                name: 'settingInterfaceWebSetting_interface_common',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.elements,
                  interfaceGroupId: interfaceGroups.web.setting.interface.common,
                },
              },
              {
                path: 'text',
                name: 'settingInterfaceWebSetting_interface_text',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.texts,
                  interfaceGroupId: interfaceGroups.web.setting.interface.text,
                },
              },
            ],
          },
          {
            path: 'offer-agreement',
            name: 'settingInterfaceWebSetting_offerAgreement',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },

            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages.offer_agreement,
            },
            children: [
              {
                path: 'buttons',
                name: 'settingInterfaceWebSetting_offerAgreement_buttons',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.buttons,
                  interfaceGroupId: interfaceGroups.web.setting.offer_agreement.buttons,
                },
              },
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_offerAgreement_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.offer_agreement.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'labels',
                name: 'settingInterfaceWebSetting_offerAgreement_labels',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.offer_agreement.labels,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
                },
              },
              {
                path: 'tooltips',
                name: 'settingInterfaceWebSetting_offerAgreement_tooltips',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.offer_agreement.tooltips,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.tooltips,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_offerAgreement_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'publish',
                    name: 'settingInterfaceWebSetting_offerAgreement_dialogs_publish',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.offer_agreement.dialog.publish.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-offer_agreement']['dialog-publish-buttons']
                          .publish,
                    },
                    children: [
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_offerAgreement_dialogs_publish_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.offer_agreement.dialog.publish.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'confirm',
                    name: 'settingInterfaceWebSetting_offerAgreement_dialogs_confirm',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.offer_agreement.dialog.confirm.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-offer_agreement']['dialog-confirm'].titles,
                    },
                    children: [
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_offerAgreement_dialogs_confirm_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.offer_agreement.dialog.confirm.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: 'business-segment',
            name: 'settingInterfaceWebSetting_businessSegment',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },

            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages.setting.pages['segmenty-vida-deyatelnosti'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_businessSegment_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.businessSegment.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_businessSegment_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWebSetting_businessSegment_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.businessSegment.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_businessSegment_dialogs_addEdit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.businessSegment.dialogs.addEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'inputs',
                        name: 'settingInterfaceWebSetting_businessSegment_dialogs_addEdit_inputs',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.businessSegment.dialogs.addEdit.inputs,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.inputs,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_businessSegment_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.businessSegment.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_businessSegment_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.businessSegment.dialogs.delete,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'project-type',
            name: 'settingInterfaceWebSetting_projectType',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['tipy-proektov'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_projectType_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.projectType.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_projectType_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWebSetting_projectType_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.projectType.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_projectType_dialogs_addEdit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.projectType.dialogs.addEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'inputs',
                        name: 'settingInterfaceWebSetting_projectType_dialogs_addEdit_inputs',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.projectType.dialogs.addEdit.inputs,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.inputs,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_projectType_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.projectType.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_projectType_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.projectType.dialogs.delete,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'work-type-category',
            name: 'settingInterfaceWebSetting_workTypeCategory',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['kategorii-rabot'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_workTypeCategory_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.workTypeCategory.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_workTypeCategory_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWebSetting_workTypeCategory_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.workTypeCategory.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_workTypeCategory_dialogs_addEdit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.workTypeCategory.dialogs.addEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'inputs',
                        name: 'settingInterfaceWebSetting_workTypeCategory_dialogs_addEdit_inputs',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.workTypeCategory.dialogs.addEdit.inputs,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.inputs,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_workTypeCategory_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.workTypeCategory.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_workTypeCategory_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId: interfaceGroups.web.setting.workTypeCategory.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'work-extra-type',
            name: 'settingInterfaceWebSetting_workExtraType',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages.setting.pages['vidy-dopolnitelnyh-rabot'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_workExtraType_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.workExtraType.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_workExtraType_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWebSetting_workExtraType_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.workExtraType.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_workExtraType_dialogs_addEdit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.workExtraType.dialogs.addEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_workExtraType_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.workExtraType.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_workExtraType_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId: interfaceGroups.web.setting.workExtraType.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'work-type',
            name: 'settingInterfaceWebSetting_workType',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['vidy-rabot'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_workType_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.workType.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_workType_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWebSetting_workType_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.workType.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_workType_dialogs_addEdit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.workType.dialogs.addEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_workType_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.workType.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_workType_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId: interfaceGroups.web.setting.workType.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'region',
            name: 'settingInterfaceWebSetting_region',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['regiony'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_region_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.region.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_region_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWebSetting_region_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.region.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_region_dialogs_addEdit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.region.dialogs.addEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_region_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.region.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_region_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId: interfaceGroups.web.setting.region.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'employee-roles',
            name: 'settingInterfaceWebSetting_employeeRoles',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['dolzhnosti'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_employeeRoles_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.employeeRoles.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_employeeRoles_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWebSetting_employeeRoles_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId:
                        interfaceGroups.web.setting.employeeRoles.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_employeeRoles_dialogs_addEdit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.employeeRoles.dialogs.addEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_employeeRoles_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.employeeRoles.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_employeeRoles_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId: interfaceGroups.web.setting.employeeRoles.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'scheme-type',
            name: 'settingInterfaceWebSetting_schemeType',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['tip-chertezha'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_schemeType_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.schemeType.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_schemeType_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWebSetting_schemeType_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.schemeType.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_schemeType_dialogs_addEdit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.schemeType.dialogs.addEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_schemeType_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.schemeType.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_schemeType_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId: interfaceGroups.web.setting.schemeType.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'document-type',
            name: 'settingInterfaceWebSetting_documentType',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['tip-dokumenta'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_documentType_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.documentType.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_documentType_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWebSetting_documentType_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.documentType.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_documentType_dialogs_addEdit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.documentType.dialogs.addEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_documentType_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.documentType.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_documentType_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId: interfaceGroups.web.setting.documentType.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'work-area',
            name: 'settingInterfaceWebSetting_workArea',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['zona-raboty'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_workArea_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.workArea.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_workArea_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWebSetting_workArea_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.workArea.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_workArea_dialogs_addEdit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.workArea.dialogs.addEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_workArea_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.workArea.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_workArea_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId: interfaceGroups.web.setting.workArea.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'scheme-class',
            name: 'settingInterfaceWebSetting_schemeСlass',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages.setting.pages['soderzhanie-chertezhey'],
            },
            children: [
              {
                path: 'tables',
                name: 'settingInterfaceWebSetting_schemeСlass_tables',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.schemeСlass.tables,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting_schemeСlass_dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                redirect: {
                  name: 'settingInterfaceWeb',
                },

                meta: {
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.dialogs,
                },
                children: [
                  {
                    path: 'add-edit',
                    name: 'settingInterfaceWebSetting_schemeСlass_dialogs_addEdit',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      interfaceGroupId: interfaceGroups.web.setting.schemeСlass.dialogs.addEdit.id,
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common['dialogs-add_edit'],
                    },
                    children: [
                      {
                        path: 'labels',
                        name: 'settingInterfaceWebSetting_schemeСlass_dialogs_addEdit_labels',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.schemeСlass.dialogs.addEdit.labels,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.labels,
                        },
                      },
                      {
                        path: 'buttons',
                        name: 'settingInterfaceWebSetting_schemeСlass_dialogs_addEdit_buttons',
                        component: () =>
                          import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                        meta: {
                          interfaceGroupId:
                            interfaceGroups.web.setting.schemeСlass.dialogs.addEdit.buttons,
                          breadCrumbLocalStorage: 'translations',
                          breadCrumb: (translation) =>
                            translation.pages['setting-interface'].common.buttons,
                        },
                      },
                    ],
                  },
                  {
                    path: 'delete',
                    name: 'settingInterfaceWebSetting_schemeСlass_dialogs_delete',
                    component: () =>
                      import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                    meta: {
                      breadCrumbLocalStorage: 'translations',
                      breadCrumb: (translation) =>
                        translation.pages['setting-interface'].common.delete,
                      interfaceGroupId: interfaceGroups.web.setting.schemeСlass.dialogs.delete,
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'structure-company',
            name: 'settingInterfaceWebSetting_structureCompany',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },
            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['structure_company'],
            },
            children: [
              {
                path: 'titles',
                name: 'settingInterfaceWebSetting_structureCompany_titles',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.structureCompany.titles,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.titles,
                },
              },
              {
                path: 'labels',
                name: 'settingInterfaceWebSetting_structureCompany_labels',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.structureCompany.labels,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
                },
              },
              {
                path: 'buttons',
                name: 'settingInterfaceWebSetting_structureCompany_buttons',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.structureCompany.buttons,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.buttons,
                },
              },
            ],
          },
          {
            path: 'setting-company',
            name: 'settingInterfaceWebSetting_settingCompany',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.setting.settingCompany.all,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['setting_company'],
            },
          },
          {
            path: 'push-notifications',
            name: 'settingInterfaceWebSetting-pushNotifications',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.setting.pushNotifications.main,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.setting.pages['push_notifications'],
            },
            children: [
              {
                path: 'statuses',
                name: 'settingInterfaceWebSetting-pushNotifications-statuses',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.pushNotifications.statuses,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-push_notifications'].main.status,
                },
              },
              {
                path: 'dialogs',
                name: 'settingInterfaceWebSetting-pushNotifications-dialogs',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.pushNotifications.dialogs,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.dialogs,
                },
              },
              {
                path: 'types',
                name: 'settingInterfaceWebSetting-pushNotifications-types',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.pushNotifications.types,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-push_notifications'].main.type,
                },
              },
              {
                path: 'triggers',
                name: 'settingInterfaceWebSetting-pushNotifications-triggers',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.pushNotifications.triggers,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-push_notifications'].main.trigger,
                },
              },

            ],
          },
          {
            path: 'finance',
            name: 'settingInterfaceWebSettingFinance',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.setting.settingsFinance,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.pages.buttons.finance,
            },
          },
        ],
      },
      {
        path: 'free-documents',
        name: 'settingInterfaceWeb_freeDocuments',
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        redirect: {
          name: 'settingInterfaceWeb',
        },
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['free_documents'],
        },
        children: [
          {
            path: 'pages',
            name: 'settingInterfaceWeb_freeDocuments_pages',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.setting.freeDocuments.pages,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.pages_name,
            },
          },
          {
            path: 'tables',
            name: 'settingInterfaceWeb_freeDocuments_tables',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.setting.freeDocuments.tables,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.tables,
            },
          },
          {
            path: 'dialogs',
            name: 'settingInterfaceWeb_freeDocuments_dialogs',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            redirect: {
              name: 'settingInterfaceWeb',
            },

            meta: {
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.dialogs,
            },
            children: [
              {
                path: 'titles',
                name: 'settingInterfaceWeb_freeDocuments_dialogs_titles',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.freeDocuments.dialogs.titles,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.titles,
                },
              },
              {
                path: 'labels',
                name: 'settingInterfaceWeb_freeDocuments_dialogs_labels',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.freeDocuments.dialogs.labels,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
                },
              },
              {
                path: 'buttons',
                name: 'settingInterfaceWeb_freeDocuments_dialogs_buttons',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.web.setting.freeDocuments.dialogs.buttons,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.buttons,
                },
              },
            ],
          },
        ],
      },
      {
        path: 'auth',
        name: 'settingInterfaceWeb_auth',
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        redirect: {
          name: 'settingInterfaceWeb',
        },
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages['setting-interface'].common.auth,
        },
        children: [
          {
            path: 'titles',
            name: 'settingInterfaceWeb_auth_titles',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.auth.titles,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.titles,
            },
          },
          {
            path: 'labels',
            name: 'settingInterfaceWeb_auth_labels',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.auth.labels,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
            },
          },
          {
            path: 'buttons',
            name: 'settingInterfaceWeb_auth_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.auth.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
        ],
      },
      {
        path: 'common-elements',
        name: 'settingInterfaceWeb_commonElements',
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        redirect: {
          name: 'settingInterfaceWeb',
        },
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages['setting-interface'].common.elements,
        },
        children: [
          {
            path: 'buttons',
            name: 'settingInterfaceWeb_commonElements_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.commonElements.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
          {
            path: 'notifications',
            name: 'settingInterfaceWeb_commonElements_notifications',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.commonElements.notifications,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-interface'].common.notifications,
            },
          },
          {
            path: 'pagination',
            name: 'settingInterfaceWeb_commonElements_pagination',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.commonElements.pagination,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.pagination,
            },
          },
          {
            path: 'rules',
            name: 'settingInterfaceWeb_commonElements_rules',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.commonElements.rules,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-interface'].common.inputs_error,
            },
          },
          {
            path: 'breadcrumbs',
            name: 'settingInterfaceWeb_commonElements_breadcrumbs',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.commonElements.breadcrumbs,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-interface'].common.breadcrumbs,
            },
          },
          {
            path: 'text',
            name: 'settingInterfaceWeb_commonElements_text',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.commonElements.text,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.texts,
            },
          },
          {
            path: 'checkbox',
            name: 'settingInterfaceWeb_commonElements_checkbox',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.commonElements.checkbox,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.checkbox,
            },
          },
          {
            path: 'measure',
            name: 'settingInterfaceWeb_commonElements_measure',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.commonElements.measure,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.measure,
            },
          },
        ],
      },
      {
        path: 'error',
        name: 'settingInterfaceWeb_error',
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          interfaceGroupId: interfaceGroups.web.error.main,
          breadCrumb: '404',
        },
      },
      {
        path: 'finance',
        name: 'settingInterfaceWebFinance',
        redirect: {
          name: 'settingInterfaceWeb',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.pages.buttons.finance,
        },
        children: [
          {
            path: 'pages',
            name: 'settingInterfaceWebFinancePages',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.finance.pages,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.pages_name,
            },
          },
          {
            path: 'salary',
            name: 'settingInterfaceWebFinanceSalary',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.finance.salary,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.finance.pages.salary,
            },
          },
          {
            path: 'period',
            name: 'settingInterfaceWebFinancePeriod',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.finance.period,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.projects.pages.reports,
            },
          },
          {
            path: 'invoice',
            name: 'settingInterfaceWebFinanceInvoice',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.finance.invoice,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.finance.pages.invoice,
            },
          },
          {
            path: 'invoice-status',
            name: 'settingInterfaceWebFinanceInvoiceStatus',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.web.finance.invoice_status,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.status,
            },
          },
        ]
      }
    ],
  },
]
